import * as React from "react";
import {useEffect, useState} from "react";
import {getRiskcovryLink} from "InsuranceV2/api";
import ContainerBox from "myshubhlife-component/container-box";
import {FlashCard} from "web-com";
import {getIdToken} from "service";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {RouteComponentProps} from "react-router-dom";
import {getInsuranceRoutes} from "InsuranceV2/routes";
import {IActiveInsuranceList} from "InsuranceV2/ActiveInsurances";
import {isWebview} from "utils";
import {MessageType} from "utils/variables";
import {IReduxState} from "reducers";
import {connect} from "react-redux";

export interface IInsuranceDetails {
    link: string;
    active: IActiveInsuranceList[];
    utm_source?: string;
}

interface IConnectProps {
    utm_source?: string;
}

export const redirectToRiskcovry = (link: string) => {
    if (isWebview()) {
        setAndroidTokenAndVersionBeforeRedirecting(null, getIdToken());
    }
    window.open(link, "_self");
};

const InsuranceV2 = (props: RouteComponentProps & IConnectProps) => {
    const [error, setError] = useState<string | null>(null);
    const [insuranceDetails, setInsuranceDetails] = useState<IInsuranceDetails>({link: null, active: []});

    const handleRiskcovryLinkRequest = async () => {
        try {
            const res = await getRiskcovryLink();
            if (res.link && res.oldActiveInsurances && res.oldActiveInsurances.length) {
                setInsuranceDetails({
                    link: res.link,
                    active: res.oldActiveInsurances,
                });
            } else if (res.link) {
                setInsuranceDetails((prev) => ({...prev, link: res.link}));
            }
        } catch (e) {
            setError(e.response?.data?.message || "Something went wrong!");
        }
    };
    useEffect(() => {
        handleRiskcovryLinkRequest();
    }, []);

    return (!error)
        ? getInsuranceRoutes(props.match.path, insuranceDetails)
        : <ContainerBox>
            <FlashCard
                messageType={MessageType.ERROR}
                heading={error}
                supportEmail= {true}
            />
        </ContainerBox>;
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(InsuranceV2);

